module.exports = __webpack_public_path__ + "static/IS2-ca6be5969b729e6e3f639d5d9292bfa1.jpg";